import styled from "styled-components"

export const StyleWookey = styled.div`
    @media ${({ theme }) => theme.device.mobile} {
        font-size: 12px;
    }
`;